"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Printer: ['printer', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.967,10.333,21.216,5.944A1.49,1.49,0,0,0,19.824,5H17.751a.249.249,0,0,1-.25-.25V2.858a1,1,0,0,0-.32-.732l-2-1.858A1,1,0,0,0,14.5,0h-7a1,1,0,0,0-1,1v3.75a.25.25,0,0,1-.25.25H4.177a1.488,1.488,0,0,0-1.391.943L1.034,10.333a.724.724,0,0,0-.03.23L1.9,17.687A1.5,1.5,0,0,0,3.383,19H4.707a.249.249,0,0,1,.242.314l-.914,3.428A1,1,0,0,0,5,24H18.5a1,1,0,0,0,.965-1.258l-.914-3.428A.25.25,0,0,1,18.794,19h1.824a1.5,1.5,0,0,0,1.488-1.314L23,10.558A1.01,1.01,0,0,0,22.967,10.333ZM15.251,7h-6.5a.249.249,0,0,1-.25-.25v-4.5A.249.249,0,0,1,8.751,2H14.01a.253.253,0,0,1,.17.066l1.241,1.152a.252.252,0,0,1,.08.184V6.751A.25.25,0,0,1,15.251,7Zm5.25,6a1,1,0,1,1-1-1A1,1,0,0,1,20.5,13ZM7.72,16.686a.249.249,0,0,1,.241-.185H15.54a.249.249,0,0,1,.241.185l1.334,5a.25.25,0,0,1-.242.315H6.628a.25.25,0,0,1-.242-.315Z']],
  Scanner: ['scanner', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.334,20a.249.249,0,0,0-.247.29C.458,22.593,2.448,24,5.5,24h13c3.052,0,5.042-1.408,5.413-3.71a.249.249,0,0,0-.247-.29ZM19.5,21a.75.75,0,1,1-.75.75A.75.75,0,0,1,19.5,21Zm-3,0a.75.75,0,1,1-.75.75A.75.75,0,0,1,16.5,21Z', 'M4.031,9.751a.25.25,0,0,0-.232.157L.3,18.658A.25.25,0,0,0,.531,19H23.469a.25.25,0,0,0,.232-.343l-3.5-8.75a.25.25,0,0,0-.232-.157Zm15.883,7.53a.5.5,0,0,1-.414.22H4.5a.5.5,0,0,1-.464-.686l2-5A.5.5,0,0,1,6.5,11.5h11a.5.5,0,0,1,.464.314l2,5A.5.5,0,0,1,19.914,17.281Z', 'M20.09,8.251a.251.251,0,0,0,.244-.2L21.988.609A.5.5,0,0,0,21.5,0H2.5a.5.5,0,0,0-.488.608L3.666,8.055a.251.251,0,0,0,.244.2Z']]
};
exports["default"] = _default;